import { Store, useStore } from '../../lib/store.ts';

const readBool = (key: string, fallback: boolean) => {
  try {
    const v = localStorage.getItem(key);
    return v === null ? fallback : v === '1';
  } catch {
    return fallback;
  }
};
const writeBool = (key: string, v: boolean) => {
  try {
    localStorage.setItem(key, v ? '1' : '0');
  } catch {
    /* ignore */
  }
};

export const paletteStore = new Store<{ open: boolean; query: string }>({ open: false, query: '' });
export const openPalette = (query = '') => paletteStore.set({ open: true, query });
export const closePalette = () => paletteStore.set({ open: false, query: '' });
export const usePalette = () => useStore(paletteStore);

export const sidebarCollapsed = new Store(readBool('tomo.sidebarCollapsed', false));
export function toggleSidebar() {
  const next = !sidebarCollapsed.get();
  sidebarCollapsed.set(next);
  writeBool('tomo.sidebarCollapsed', next);
}

export const mobileNavOpen = new Store(false);

/** "New project" dialog. It lives in the project shell: there is no project list page. */
export const newProjectOpen = new Store(false);
export const openNewProject = () => newProjectOpen.set(true);

/**
 * "New collection" dialog. Collections start from scratch: a name, an icon and some views.
 * `groupId` is the group the new collection lands in, set when the dialog is opened from one.
 */
export const newCollectionOpen = new Store<{ open: boolean; groupId: string | null }>({ open: false, groupId: null });
export const openNewCollection = (groupId: string | null = null) => newCollectionOpen.set({ open: true, groupId });
export const closeNewCollection = () => newCollectionOpen.set({ open: false, groupId: null });

export function useCollapsedSection(id: string): [boolean, () => void] {
  const store = sectionStores.get(id) ?? sectionStores.set(id, new Store(readBool(`tomo.section.${id}`, false))).get(id)!;
  const collapsed = useStore(store);
  return [
    collapsed,
    () => {
      store.set(!collapsed);
      writeBool(`tomo.section.${id}`, !collapsed);
    },
  ];
}
const sectionStores = new Map<string, Store<boolean>>();
